<!-- Builder Start -->
<div id="{{position}}">
  <div *ngIf="!loading">
    <header class="app-header-background" [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="contenedor global-max-width">
        <div class="container-bloque" [ngClass]="classMember" *ngFor="let career of careers;let careerIndex = index">
          <div class="bloque">
            <div>
              <mat-icon class="career-icons">work</mat-icon> <span
                [ngStyle]="{ 'color': career.textColor }">{{career.title}}</span>
            </div>
            <ul>
              <li *ngFor="let experience of career.experiences;let experienceIndex = index"
                [attr.data-aos]="itemsAnimation ? itemsAnimation : null">
                <mat-icon class="date-icons">event</mat-icon><span class="date-span"
                  [ngStyle]="{ 'color': career.textColor }">{{experience.startMonth}} {{experience.startYear}} -
                  {{experience.endMonth}} {{experience.endYear}}</span>
                <strong [ngStyle]="{ 'color': career.textColor }">{{experience.title}}</strong>
                <p [ngStyle]="{ 'color': career.textColor }">{{experience.description}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>

<!-- Builder End -->